import { Text } from '@/components';
import { Tooltip as AntTooltip, type TooltipProps } from 'antd';
import type { FC } from 'react';

const DEFAULT_MAX_WIDTH = '320px';
const DEFAULT_MAX_HEIGHT = '300px';

export const Tooltip: FC<TooltipProps> = ({ children, title, ...props }) => {
  const overlayStyle = {
    ...props.overlayStyle,
    maxWidth: props.overlayStyle?.maxWidth || DEFAULT_MAX_WIDTH,
  };

  const overlayInnerStyle = {
    ...props.overlayInnerStyle,
    maxHeight: props.overlayInnerStyle?.maxHeight || DEFAULT_MAX_HEIGHT,
    overflowY: 'auto' as const,
    overscrollBehavior: 'contain' as const,
  };

  return (
    <AntTooltip
      title={typeof title === 'string' ? <Text text={title} /> : title}
      overlayStyle={overlayStyle}
      overlayInnerStyle={overlayInnerStyle}
      data-dd-privacy="allow"
      {...props}
    >
      {children}
    </AntTooltip>
  );
};
